import { Protocol } from '../../models/Entities/Protocols/Protocol';
import { AppThunkAction } from '../reducers';

// services
import * as Services from '../../services/MedicalProtocols.Services';

// actions
import * as Actions from '../actions';

// models
import { ProtocolContract } from '../../models/Entities/Protocols/ProtocolContracts';
import { ContractProtocolAssociation } from '../../models/Entities/Contracts/ContractProtocolAssociation';
import { ProtocolPatient } from '../../models/Entities/Protocols/ProtocolPatient';
import { ProtocolPatientContractBranch, ProtocolPatientContractBranchUpsertPayload } from '../../models/Entities/Protocols/ProtocolPatientContractBranch';
import { PatientVisit } from '../../models/Entities/Protocols/PatientVisist';
import { ErrorType } from '../../models/HttpError';
import { ProtocolVisit } from '../../models/Entities/Protocols/ProtocolVisit';
import { ContractStage } from '../../models/Entities/Contracts/ContractStage';

type KnownAction =
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_Fail_Action
    | Actions.MedicalProtocols.MedicalProtocols_UpdateAll_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_UpdateAll_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_UpdateAll_Fail_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetById_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetById_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetById_Fail_Action
    | Actions.MedicalProtocols.MedicalProtocols_Contract_Association_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_Contract_Association_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_Contract_Association_Fail_Action
    | Actions.MedicalProtocols.MedicalProtocols_Contract_Disassociation_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_Contract_Disassociation_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_Contract_Disassociation_Fail_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_ContractAssociations_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_ContractAssociations_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_ContractAssociations_Fail_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_ProtocolPatients_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_ProtocolPatients_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_ProtocolPatients_Fail_Action
    | Actions.MedicalProtocols.MedicalProtocolsGetAllProtocolPatientContractBranchesRequestAction
    | Actions.MedicalProtocols.MedicalProtocolsGetAllProtocolPatientContractBranchesReceiveAction
    | Actions.MedicalProtocols.MedicalProtocolsGetAllProtocolPatientContractBranchesFailAction
    | Actions.MedicalProtocols.MedicalProtocolsSetProtocolPatientContractBranchRequestAction
    | Actions.MedicalProtocols.MedicalProtocolsSetProtocolPatientContractBranchReceiveAction
    | Actions.MedicalProtocols.MedicalProtocolsSetProtocolPatientContractBranchFailAction
    | Actions.MedicalProtocols.MedicalProtocolsDeleteProtocolPatientContractBranchRequestAction
    | Actions.MedicalProtocols.MedicalProtocolsDeleteProtocolPatientContractBranchReceiveAction
    | Actions.MedicalProtocols.MedicalProtocolsDeleteProtocolPatientContractBranchFailAction
    | Actions.MedicalProtocols.MedicalProtocols_GetByPractitionerId_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetByPractitionerId_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetByPractitionerId_Fail_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_PatientVisit_ByProtocolId_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_PatientVisit_ByProtocolId_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_PatientVisit_ByProtocolId_Fail_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_ByProtocolId_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_ByProtocolId_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_ByProtocolId_Fail_Action

    // get protocol visit full
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_Full_ByProtocolId_Request_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_Full_ByProtocolId_Receive_Action
    | Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_Full_ByProtocolId_Fail_Action

      // PDF and Excel export actions
    | Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsPdfRequestAction
    | Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsPdfReceiveAction
    | Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsPdfFailAction
    | Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsExcelRequestAction
    | Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsExcelReceiveAction
    | Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsExcelFailAction

    // Export Protocol Visits to Excel
    | Actions.MedicalProtocols.GetProtocolVisitsExcelFailureAction
    | Actions.MedicalProtocols.GetProtocolVisitsExcelSuccessAction
    | Actions.MedicalProtocols.GetProtocolVisitsExcelRequestAction;

export const actionCreators = {
    GetAllMedicalProtocols: (): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            
            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GET_ALL_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            if (!state.MedicalProtocols?.successLoadingAll) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GET_ALL_REQUEST_ACTION'
                });

                Services.GetAllProtocols(token)
                    .then((MedicalProtocols: Protocol[]) => {
                        dispatch({
                            type: 'MEDICALPROTOCOLS_GET_ALL_RECEIVE_ACTION',
                            MedicalProtocols: MedicalProtocols
                        });
                    })
                    .catch((error: ErrorType) =>
                        dispatch({
                            type: 'MEDICALPROTOCOLS_GET_ALL_FAIL_ACTION',
                            error: error
                        })
                    );
            } else {
                dispatch({
                    type: 'MEDICALPROTOCOLS_UPDATE_ALL_REQUEST_ACTION'
                });

                Services.GetAllProtocols(token)
                    .then((MedicalProtocols: Protocol[]) => {
                        dispatch({
                            type: 'MEDICALPROTOCOLS_UPDATE_ALL_RECEIVE_ACTION',
                            MedicalProtocols: MedicalProtocols
                        });
                    })
                    .catch((error: ErrorType) =>
                        dispatch({
                            type: 'MEDICALPROTOCOLS_UPDATE_ALL_FAIL_ACTION',
                            error: error
                        })
                    );
            }
        },
    GetMedicalProtocolById:
        (protocolId: number): AppThunkAction<KnownAction> =>
            async (dispatch, getState) => {

                var state = getState();
                var token: string;

                if (state.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GET_BY_ID_FAIL_ACTION',
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = state.oidc.user.access_token;
                }

                if (state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === protocolId )) return;

                dispatch({
                    type: 'MEDICALPROTOCOLS_GET_BY_ID_REQUEST_ACTION',
                    protocolId: protocolId
                });

                Services.GetProtocolById(protocolId, token)
                    .then((MedicalProtocol: Protocol) => {
                        dispatch({
                            type: 'MEDICALPROTOCOLS_GET_BY_ID_RECEIVE_ACTION',
                            MedicalProtocol: MedicalProtocol
                        });
                    })
                    .catch((error: ErrorType) =>
                        dispatch({
                            type: 'MEDICALPROTOCOLS_GET_BY_ID_FAIL_ACTION',
                            error: error
                        })
                    );
            },
    AssociateContract: (
        protocolId: number,
        contractId: number
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getSate) => {

            var state = getSate();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_CONTRACT_ASSOCIATION_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }


            dispatch({
                type: 'MEDICALPROTOCOLS_CONTRACT_ASSOCIATION_REQUEST_ACTION',
                ProtocolId: protocolId,
                ContractId: contractId
            });

            Services.AssociateContract(protocolId, contractId, token)
                .then((contract: ProtocolContract) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_CONTRACT_ASSOCIATION_RECEIVE_ACTION',
                        ProtocolContract: contract
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'MEDICALPROTOCOLS_CONTRACT_ASSOCIATION_FAIL_ACTION',
                        error: error
                    })
                );
        };
    },
    DisassociateContract: (
        ProtocolContractId: number,
        ProtocolId: number
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_CONTRACT_DISASSOCIATION_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }


            dispatch({
                type: 'MEDICALPROTOCOLS_CONTRACT_DISASSOCIATION_REQUEST_ACTION',
                ProtocolContractId: ProtocolContractId,
                ProtocolId: ProtocolId
            });

            Services.DisassociateContract(ProtocolContractId, token)
                .then((contract: ProtocolContract) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_CONTRACT_DISASSOCIATION_RECEIVE_ACTION',
                        ProtocolContractId: ProtocolContractId,
                        ProtocolId: ProtocolId
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'MEDICALPROTOCOLS_CONTRACT_DISASSOCIATION_FAIL_ACTION',
                        error: error
                    })
                );
        };
    },
    GetAllProtocolContractAssociations: (
        protocolId: number
    ): AppThunkAction<KnownAction> => {

        return async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_REQUEST_ACTION',
                ProtocolId: protocolId
            });
            
            Services.GetProtocolContracts(protocolId, token)
                .then((contract: ContractProtocolAssociation) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_RECEIVE_ACTION',
                        contractAssociation: contract,
                        ProtocolId: protocolId
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_FAIL_ACTION',
                        error: error
                    })
                );
        };
    },
    GetProtocolPatients: (
        protocolId: number,
        searchText: string | null
    ): AppThunkAction<KnownAction> => {

        return async (dispatch, getState) => {
            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENTS_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENTS_REQUEST_ACTION',
                ProtocolId: protocolId
            });

            Services.GetProtocolPatients(protocolId, searchText, token)
                .then((Patients: ProtocolPatient[]) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENTS_RECEIVE_ACTION',
                        ProtocolId: protocolId,
                        ProtocolPatients: Patients
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENTS_FAIL_ACTION',
                        error: error
                    });
                });
        };
    },
    GetProtocolPatientContractBranches: (
        protocolId: number
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {
            const state = getState();
            let token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENT_CONTRACTBRANCHES_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENT_CONTRACTBRANCHES_REQUEST_ACTION',
                ProtocolId: protocolId
            });

            Services.GetProtocolPatientContractBranches(protocolId, token)
                .then((ProtocolPatientContractBranches: ProtocolPatientContractBranch[]) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENT_CONTRACTBRANCHES_RECEIVE_ACTION',
                        ProtocolId: protocolId,
                        ProtocolPatientContractBranches
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENT_CONTRACTBRANCHES_FAIL_ACTION',
                        error
                    });
                });
        };
    },
    SetProtocolPatientContractBranch: (
        protocolId: number,
        numberInProtocol: string,
        contractBranchId: number,
        contractBranchName: string,
        dateFrom: Date | string,
        dateTo?: Date | string | null,
        existingId?: string
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {
            const state = getState();
            let token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_SET_PROTOCOLPATIENT_CONTRACTBRANCH_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_SET_PROTOCOLPATIENT_CONTRACTBRANCH_REQUEST_ACTION',
                ProtocolId: protocolId,
                NumberInProtocol: numberInProtocol,
                ContractBranchId: contractBranchId,
                ContractBranchName: contractBranchName,
                DateFrom: dateFrom,
                DateTo: dateTo
            });

            const payload: ProtocolPatientContractBranchUpsertPayload = {
                protocolId,
                numberInProtocol,
                contractBranchId,
                contractBranchName,
                dateFrom,
                dateTo
            };

            const savePromise = existingId
                ? Services.UpdateProtocolPatientContractBranch(existingId, payload, token)
                : Services.CreateProtocolPatientContractBranch(payload, token);

            savePromise
                .then((ProtocolPatientContractBranch: ProtocolPatientContractBranch) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_SET_PROTOCOLPATIENT_CONTRACTBRANCH_RECEIVE_ACTION',
                        ProtocolId: protocolId,
                        ProtocolPatientContractBranch
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_SET_PROTOCOLPATIENT_CONTRACTBRANCH_FAIL_ACTION',
                        error
                    });
                });
        };
    },
    DeleteProtocolPatientContractBranch: (
        protocolId: number,
        id: string,
        numberInProtocol: string
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {
            const state = getState();
            let token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_DELETE_PROTOCOLPATIENT_CONTRACTBRANCH_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_DELETE_PROTOCOLPATIENT_CONTRACTBRANCH_REQUEST_ACTION',
                ProtocolId: protocolId,
                Id: id,
                NumberInProtocol: numberInProtocol
            });

            Services.DeleteProtocolPatientContractBranch(id, token)
                .then(() => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_DELETE_PROTOCOLPATIENT_CONTRACTBRANCH_RECEIVE_ACTION',
                        ProtocolId: protocolId,
                        Id: id,
                        NumberInProtocol: numberInProtocol
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_DELETE_PROTOCOLPATIENT_CONTRACTBRANCH_FAIL_ACTION',
                        error
                    });
                });
        };
    },
    GetProtocolsByPractitionerId: (
        practitionerId: string
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if(state.Practitioners?.list.find((practitioner) => practitioner.userId === practitionerId)?.Protocols) return;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GET_BY_PRACTITIONER_ID_FAIL_ACTION',
                    practitionerId: practitionerId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_GET_BY_PRACTITIONER_ID_REQUEST_ACTION',
                practitionerId: practitionerId
            });

            Services.GetProtocolByPractitionerId(practitionerId, token)
                .then((Protocols: Protocol[]) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GET_BY_PRACTITIONER_ID_RECEIVE_ACTION',
                        practitionerId: practitionerId,
                        MedicalProtocols: Protocols
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GET_BY_PRACTITIONER_ID_FAIL_ACTION',
                        practitionerId: practitionerId,
                        error: error
                    })
                );
        };
    },
    GetPatientVisitByProtocolId: (
        protocolId: number
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_PATIENTVISIT_BYPROTOCOLID_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_GETALL_PATIENTVISIT_BYPROTOCOLID_REQUEST_ACTION',
                ProtocolId: protocolId
            });

            Services.GetProtocolPatientVisits(protocolId, token)
                .then((PatientVisits: PatientVisit[]) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GETALL_PATIENTVISIT_BYPROTOCOLID_RECEIVE_ACTION',
                        ProtocolId: protocolId,
                        visits: PatientVisits
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GETALL_PATIENTVISIT_BYPROTOCOLID_FAIL_ACTION',
                        error: error
                    })
                );
        };
    },
    GetVisitFullByProtocolId: (
        protocolId: number
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_FAIL_ACTION',
                    ProtocolId: protocolId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_REQUEST_ACTION',
                ProtocolId: protocolId
            });

            Services.GetProtocolVisitsFull(protocolId, token)
            .then((visits: ContractStage[]) => {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_RECEIVE_ACTION',
                    ProtocolId: protocolId,
                    visits: visits
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_FAIL_ACTION',
                    error: error,
                    ProtocolId: protocolId
                })
            );
        }
    },
    GetVisitsByProtocolId: (
        protocolId: number
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_FAIL_ACTION',
                    ProtocolId: protocolId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_REQUEST_ACTION',
                ProtocolId: protocolId
            });

            Services.GetProtocolVisits(protocolId, token)
            .then((PatientVisits: ProtocolVisit[]) => {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_RECEIVE_ACTION',
                    ProtocolId: protocolId,
                    visits: PatientVisits.filter((visit: ProtocolVisit) => 
                        visit.state === 1
                    ).sort((a: ProtocolVisit, b: ProtocolVisit) => a.order - b.order)
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_FAIL_ACTION',
                    error: error,
                    ProtocolId: protocolId
                })
            );
        };
    },
    GetPractitionerVisitsPdf: (
        practitionerId: string,
        dateFrom: Date,
        dateTo: Date
    ): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            const state = getState();
            let token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_FAIL_ACTION',
                    practitionerId: practitionerId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_REQUEST_ACTION',
                practitionerId: practitionerId,
                dateFrom: dateFrom,
                dateTo: dateTo
            });

            Services.GetPractitionerProtocolVisitsPdf(practitionerId, dateFrom, dateTo, token)
                .then((pdfBlob: Blob) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_RECEIVE_ACTION',
                        practitionerId: practitionerId,
                        pdfBlob: pdfBlob
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_FAIL_ACTION',
                        practitionerId: practitionerId,
                        error: error
                    })
                );
        },

    GetPractitionerVisitsExcel: (
        practitionerId: string,
        dateFrom: Date,
        dateTo: Date
    ): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            const state = getState();
            let token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_FAIL_ACTION',
                    practitionerId: practitionerId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_REQUEST_ACTION',
                practitionerId: practitionerId,
                dateFrom: dateFrom,
                dateTo: dateTo
            });

            Services.GetPractitionerProtocolVisitsExcel(practitionerId, dateFrom, dateTo, token)
                .then((excelBlob: Blob) => {
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_RECEIVE_ACTION',
                        practitionerId: practitionerId,
                        excelBlob: excelBlob
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_FAIL_ACTION',
                        practitionerId: practitionerId,
                        error: error
                    })
                );
        },
    ExportProtocolVisitsToExcel: (
        protocolId: number,
        dateFrom: Date,
        dateTo: Date
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'GET_PROTOCOL_VISITS_EXCEL_FAILURE',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'GET_PROTOCOL_VISITS_EXCEL_REQUEST',
                payload: { 
                    protocolId: protocolId,
                    dateFrom: dateFrom,
                    dateTo: dateTo
                }
            });

            Services.GetProtocolVisitsExcel(protocolId, dateFrom , dateTo, token)
                .then((excelBlob: Blob) => {
                    dispatch({
                        type: 'GET_PROTOCOL_VISITS_EXCEL_SUCCESS',
                        payload: excelBlob
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'GET_PROTOCOL_VISITS_EXCEL_FAILURE',
                        error: error
                    })
                );
        };
    }
};